import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { commonComponentImages } from '@images/common-components-images';
import { commonImages } from '@images/common-images';
import { ApiService } from '@services/api/api.service';
import { LeadManagementService } from '@services/lm-service/lead-management.service';
import { ReduxService } from '@state-management/redux.service';

@Component({
  selector: 'app-nav-users',
  templateUrl: './nav-users.component.html',
  styleUrls: ['./nav-users.component.scss'],
})
export class NavUsersComponent implements OnInit {
  @Input() roles: any = [];
  @Input() groups: any = [];
  @Input() offices: any = [];
  @Input() levels: any = [];
  @Input() staffs: any = [];
  @Input() users: any = [];
  @Input() serviceProviders: any = [];
  @Input() updateNav: any;
  @Input() resetFilters: any;

  @Output() userRoleClicked = new EventEmitter<any>();
  @Output() userContactClicked = new EventEmitter<any>();
  @Output() accessRoleClicked = new EventEmitter<any>();

  menuSideBar: boolean = false;
  loading: boolean = false;
  showContactType: boolean = true;
  showUser: boolean = true;
  showStaff: boolean = true;
  images = commonComponentImages;
  common_images = commonImages;
  contact_types = [];
  company_types = [];
  query = '';
  allCount = 0;
  teams: any[] = [];
  contactType: any[] = [];
  all_contact_count: any;

  public role_id = '';
  public filteredRoles: any;
  public filteredOffices: any;
  public filteredStaff: any;

  constructor(
    private Api: ApiService,
    private redux: ReduxService,
    public lmService: LeadManagementService
  ) {}

  ngOnInit() {
    this.getTags();
    this.getTeamList();
    this.loading = true;
    if (this.updateNav?.subscribe) {
      this.updateNav.subscribe({
        next: response => {
          if (response === true) {
            console.log('Update Nav called');
            this.getContacts(true);
          }
        },
      });
    }
    if (this.lmService.contactNavUpdated?.subscribe) {
      this.lmService.contactNavUpdated.subscribe({
        next: response => {
          if (response === true) {
            this.getContacts(true);
          }
        },
      });
    }
    if (this.resetFilters?.subscribe) {
      this.resetFilters.subscribe({
        next: response => {
          if (response) {
            this.role_id = '';
          }
        },
      });
    }
  }

  /**
   * Handles changes to input properties and updates corresponding data copies.
   * This ensures the latest values are assigned when specific properties change.
   */
  ngOnChanges(changes: SimpleChanges) {
    // Check if 'roles' has changed and update the copy
    if (changes.roles) {
      this.assignCopy('roles');
    }
    // Check if 'groups' has changed and update the copy
    if (changes.groups) {
      this.assignCopy('groups');
    }
    // Check if 'offices' has changed and update the copy
    if (changes.offices) {
      this.assignCopy('offices');
    }
    // Check if 'levels' has changed and update the copy
    if (changes.levels) {
      this.assignCopy('levels');
    }
    // Check if 'staffs' has changed and update the copy
    if (changes.staffs) {
      this.assignCopy('staffs');
    }
    // Check if 'serviceProviders' has changed and update the copy
    if (changes.serviceProviders) {
      this.assignCopy('serviceProviders');
    }
  }

  /**
   * Creates a copy of the specified data type to maintain filtered data separately.
   * This helps in filtering and manipulation without altering the original dataset.
   */
  assignCopy(type = '') {
    if (type == 'roles') {
      // Copy roles data for filtering
      this.filteredRoles = Object.assign([], this.roles);
      this.countAllData(this.filteredRoles);
    } else if (type == 'offices') {
      // Copy offices data for filtering
      this.filteredOffices = Object.assign([], this.offices);
    } else if (type == 'access') {
      // Copy roles and offices data for filtering
      this.filteredRoles = Object.assign([], this.roles);
      this.filteredOffices = Object.assign([], this.offices);
    } else if (type == 'staffs') {
      // Copy staff data for filtering
      this.filteredStaff = Object.assign([], this.staffs);
      this.countAllData(this.filteredStaff);
    }
    // Stop loading after assigning copies
    this.loading = false;
  }

  /**
   * Filters items based on the provided value and type.
   * If no value is provided, resets the filtered list using `assignCopy`.
   */
  filterItem(value, type = '') {
    if (type == 'roles') {
      if (!value) {
        this.assignCopy('roles');
      }
      this.filteredRoles = Object.assign([], this.roles).filter(item => item.name.toLowerCase().indexOf(value.toLowerCase()) > -1);
    } else if (type == 'groups') {
      if (!value) {
        this.assignCopy('groups');
      }
    } else if (type == 'offices') {
      if (!value) {
        this.assignCopy('offices');
      }
      this.filteredOffices = Object.assign([], this.offices).filter(item => item.name.toLowerCase().indexOf(value.toLowerCase()) > -1);
    } else if (type == 'levels') {
      if (!value) {
        this.assignCopy('levels');
      }
    } else if (type == 'access') {
      if (!value) {
        this.assignCopy();
      }
      this.filteredRoles = Object.assign([], this.roles).filter(item => item.name.toLowerCase().indexOf(value.toLowerCase()) > -1);
      this.filteredOffices = Object.assign([], this.offices).filter(item => item.name.toLowerCase().indexOf(value.toLowerCase()) > -1);
    } else if (type == 'staffs') {
      if (!value) {
        this.assignCopy('staffs');
      }
      this.filteredStaff = Object.assign([], this.staffs).filter(item => item.name.toLowerCase().indexOf(value.toLowerCase()) > -1);
    } else if (type == 'serviceProviders') {
      if (!value) {
        this.assignCopy('serviceProviders');
      }
    }
  }

  /**
   * Emits an event when a staff filter is clicked, sending the selected staff and role ID.
   */
  clickStaffFilter(staff, role_id) {
    var data = { staff: staff, role_id: role_id };
    this.userRoleClicked.emit(data);
  }

  /**
   * Emits an event when a user filter is clicked, sending pagination and role details.
   */
  clickUserFilter(staff, current_page, per_page, role_id, query) {
    var data = { staff: staff, current_page: current_page, per_page: per_page, role_id: role_id, query: query };
    this.userRoleClicked.emit(data);
  }

  /**
   * Emits an event when a contact filter is clicked, updating the role_id.
   */
  clickContactFilter(contact_type, contact) {
    this.role_id = contact || contact_type;
    this.groupType = contact_type?.groupType;
    let data = { contact_type: contact_type, contact: contact };
    this.userContactClicked.emit(data);
  }

  toggleContactType(event) {
    event.stopPropagation();
    this.showContactType = !this.showContactType;
    this.loading = this.contactType?.length > 0 ? false : true;
  }

  /**
   * Emits an event when an access filter is clicked, sending the type and ID.
   */
  clickAccessFilter(type, id) {
    var data = { type: type, id: id };
    this.accessRoleClicked.emit(data);
  }

  /**
   * Counts all user data except those marked as 'deactivated'.
   */
  countAllData(data: any[]) {
    this.allCount = 0;
    data.forEach(itm => {
      if (itm?.name?.toLowerCase() !== 'deactivated') {
        this.allCount += itm.user_count;
      }
    });
  }

  getTeamList() {
    if (this.Api.getOfficeId()) {
      this.Api.get('/teams?include=office,users&office_id=' + this.Api.getOfficeId()).subscribe(res => {
        this.teams = res.data;
      });
    }
  }

  allTags = [];
  getTags() {
    this.redux.getTags(this.Api.getOfficeId(), false, 'contact').subscribe({
      next: res => {
        this.allTags = [];
        this.allTags = JSON.parse(JSON.stringify(res.data));
        this.allTags[0]?.types.forEach(tag => {
          if (tag?.slug == 'contact-type') {
            this.contact_types = tag?.data?.sort((a, b) => a?.tag_name.localeCompare(b?.tag_name))?.map(ele => ele?.tag_name);
          }
          if (tag?.slug == 'company-contact-type') {
            this.company_types = tag?.data.sort((a, b) => a?.tag_name.localeCompare(b?.tag_name))?.map(ele => ele?.tag_name);
          }
        });
        this.getContacts(true);
      },
    });
  }

  newContactType = [];
  allContactData = [];
  groupType = '';
  /**
   * Fetches contact stats and maps the contact types to include an 'isOpen' property for toggling.
   * Also sets groupType property on each contact type to be either 'individual' or 'company'.
   * @param {boolean} isCache - Whether to cache the response or not.
   */
  getContacts(isCache = false) {
    let url = `/contacts/stats?office_id=${this.Api.getOfficeId()}&module_type=contact&contact_type_tags=${JSON.stringify(this.contact_types)}&company_type_tags=${JSON.stringify(this.company_types)}`;
    this.redux.getSetContactInfo(isCache, 'contacts-filter', url, ReduxService.BURST_FRESH_MS).subscribe({
      next: response => {
        const data = response?.data;
        this.allContactData = data;
        this.newContactType = data?.[0]?.types.map(group => ({
          ...group,
          isOpen: true,
          types: group.types.map(type => ({
            ...type,
            groupType: group.name.toLowerCase(),
          })),
        }));
      },
    });
  }

  /**
   * Toggles the open state of a contact group based on the provided index.
   * Stops the event from propagating further.
   *
   * @param index - The index of the contact group to toggle.
   * @param event - The event that triggered the toggle action.
   */
  toggleContactGroup(index: number, event: Event): void {
    event.stopPropagation();
    this.newContactType = this.newContactType.map((group, i) => ({
      ...group,
      isOpen: i === index ? !group.isOpen : group.isOpen,
    }));
  }
}
